module.exports = __webpack_public_path__ + "static/media/approved.b5e7acad.mp3";